/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import { Button } from "@mui/material";
import { withMyTheme } from "../../theme/theme";
import { mobileCss } from "../../util/isMobile";
import { FeatureData } from "./FeatureList";

const FeatureButtonsContainerStyle = withMyTheme(() => css`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 2rem;
  justify-content: center;
  width: 100%;
`);

const FeatureButtonStyle = withMyTheme((theme) => css`
  font-family: 'Cormorant', serif;
  text-transform: none;
  font-size: 1rem;
  padding: 8px 16px;
  border-radius: 30px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin: 4px;
  min-width: 120px;
  
  &.active {
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
  }
  
  &:not(.active) {
    background-color: rgba(0, 0, 0, 0.05);
    color: ${theme.palette.text.primary};
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  
  &.clicked {
    animation: ${pulse} 1s;
  }
  
  .MuiButton-startIcon {
    margin-right: 8px;
  }
  
  ${mobileCss(`
    font-size: 0.9rem;
    padding: 6px 12px;
    min-width: 100px;
  `)}
`);

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(196, 85, 38, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(196, 85, 38, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(196, 85, 38, 0);
  }
`;

export const FeatureSelectButtons = ({ featureData, selectedFeature, clickedButtonId, handleFeatureClick }: { featureData: FeatureData[], selectedFeature: FeatureData, clickedButtonId: string | null, handleFeatureClick: (feature: FeatureData) => void }) => {
    return (
        <div css={FeatureButtonsContainerStyle}>
            {featureData.map((feature) => (
                <Button
                    key={feature.id}
                    startIcon={feature.icon}
                    css={FeatureButtonStyle}
                    className={`
              ${selectedFeature.id === feature.id ? 'active' : ''}
              ${clickedButtonId === feature.id ? 'clicked' : ''}
            `}
                    onClick={() => handleFeatureClick(feature)}
                >
                    {feature.buttonName}
                </Button>
            ))}
        </div>
    );
};